import { Table } from 'Components/Layout';
import { useSelector } from 'react-redux';

const ErrorMessageTable: React.FC = () => {
  const errorList = useSelector((state) => state.agsValidationErrorMessages.errors);
  const tableData = errorList.map((row) => [row.LineNumber ?? '-', row.RuleName, row.GroupName, row.SourceIdentifier, row.Message]);

  return (
    <Table
      colHeaders={['Line Number', 'Rule', 'AGS Group Name', 'Source Identifier', 'Error Message']}
      colWidths={['105px', '105px', '140px', '140px',' ']}
      data={tableData}
      alternateRowShading={true}
    />
  );
};

export { ErrorMessageTable };
